export default defineNuxtRouteMiddleware((to) => {
  const { loggedIn } = useUserSession();
  const config = useRuntimeConfig();

  // Verifica se o usuário está não autenticado
  if (!loggedIn.value) {
    const baseUrl = config.public.baseUrl || ''; // Obtém a base URL do runtime config
    const callbackUrl = `${baseUrl}${to.fullPath || '/'}`; // Concatena a base URL com o caminho completo

    const allowedPaths = [
      '/signin',
      '/signup',
      '/forgot-password',
      '/confirm-account',
      '/reset-password',
    ];

    if (!allowedPaths.includes(to.path)) {
      // Evita redirecionar para a mesma rota repetidamente
      return navigateTo(`/signin?callbackUrl=${encodeURIComponent(callbackUrl)}`);
    }
  }

  // Permite a navegação para a rota de destino
  return;
});
